<template>
    <div>
        <div>
            <Titulo :titulo="'Informes - Siniestralidad Variable'" />
        </div>
        <div class="mt-3 text-center mb-5" v-if="loading">
            <img
                class="loading"
                src="@/assets/images/loader.gif"
                alt
            />
        </div>
        <div v-for="(item, index) in dataSiniestralidadVariable" :key="item.id" class="margin-informes">
            <h5 class="color-secundary">
                Configuración: {{ item.id }}
            </h5>
            <h5 class="color-secundary">
                Vigencia: {{ formatDate(item.fecha_inicio) }} - {{ formatDate(item.fecha_fin) }}
            </h5>
            <table-component
                @click-event="clickEvent"
                :data="item.productos"
                :dataLength="item.productos.length"
                :perPage="10000"
                :pagination="(dataSiniestralidadVariable.length == index + 1)"
                showExportToExcel
            >
            <table-column
            slot="label"
            :label="'Código'"
            showExportToExcel
            v-bind:value="'convenio'"
            :customClass="'text-center'"
            ></table-column>
            <table-column
            slot="label"
            :label="'Modelo'"
            showExportToExcel
            v-bind:value="'modelo'"
            :customClass="'text-center'"
            ></table-column>
            <table-column
            slot="label"
            :label="'Producto'"
            v-bind:value="'producto'"
            :customClass="'text-center'"
            ></table-column>
            <table-column
            slot="label"
            :label="'Facturado'"
            showExportToExcel
            v-bind:value="'facturado'"
            :customClass="'text-center'"
            ></table-column>
            <table-column
            slot="label"
            :label="'Valor generado para reclamación'"
            showExportToExcel
            v-bind:value="'valor_generado_para_reclamacion'"
            :customClass="'text-center'"
            ></table-column>
        </table-component>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import XLSX from "xlsx";
import saveAs from "file-saver";

export default {
    name: 'SiniestralidadVariable',
    data() {
        return {
            dataSiniestralidadVariable: [],
            loading: false,
        }
    },
    components: {
        Titulo: () => import("@/containers/layout/Titulo.vue"),
        TableComponent: () => import("@/components/table/TableComponent"),
        TableColumn: () => import("@/components/table/TableColumn"),
    },
    computed:{
        ...mapGetters({
            api: "api",
        }),
        routeName() {
            return this.$router.currentRoute.name;
        },
    },
    methods: {
        async generarInforme() {
            this.loading = true;
            let response = await this.api.get("informes/siniestralidad_variable", {})

            if(response.status == 200){
                this.dataSiniestralidadVariable = response.data;
                this.dataSiniestralidadVariable.map(item => {
                    item.productos.map(producto => {
                        producto.facturado = this.$options.filters.numberFormat(producto.facturado)
                        producto.valor_generado_para_reclamacion = this.$options.filters.numberFormat(producto.valor_generado_para_reclamacion)
                    })
                    item.productos.push({
                        producto: 'Total por configuración',
                        facturado: this.$options.filters.numberFormat(item.total_configuracion),
                        valor_generado_para_reclamacion: this.$options.filters.numberFormat(item.valor_generado_reclamacion_configuracion),
                        primary: true,
                    })

                    item.productos.push({
                        producto: 'Porcentaje de siniestralidad',
                        facturado: item.porcentaje+ "%",
                        valor_generado_para_reclamacion: "",
                        primary: true,
                    })
                })
                this.loading = false;
            }
        },
        formatDate(date) {
            return this.$moment(date).format("YYYY/MM");
        },
        clickEvent(event, slug) {
            this.loading = true;
            switch (slug) {
                case "export-to-excel":
                    this.$toasted.show("Por favor espere mientras exportamos los datos", {
                        theme: "toasted-primary",
                        position: "top-center",
                        duration: 5000,
                    });
                    try {
                        let info_to_export = Array();
                        this.dataSiniestralidadVariable.forEach(item => {
                            info_to_export.push({
                                codigo: "Configuración:",
                                modelo: item.id,
                                producto: "",
                                facturado: "",
                                valor_generado_para_reclamacion: "",
                            })
                            info_to_export.push({
                                codigo: "Vigencia:",
                                modelo: this.formatDate(item.fecha_inicio) + " - " + this.formatDate(item.fecha_fin),
                                producto: "",
                                facturado: "",
                                valor_generado_para_reclamacion: "",
                            })

                            item.productos.forEach(producto => {
                                info_to_export.push({
                                    codigo: producto.convenio,
                                    modelo: producto.modelo,
                                    producto: producto.producto,
                                    facturado: producto.facturado,
                                    valor_generado_para_reclamacion: producto.valor_generado_para_reclamacion,
                                });
                            })
                            info_to_export.push({
                                codigo: "",
                                modelo: "",
                                producto: "",
                                facturado: "",
                                valor_generado_para_reclamacion: "",
                            })
                        });
                        let data = XLSX.utils.json_to_sheet(info_to_export, {
                            header: [
                                "codigo",
                                "modelo",
                                "producto",
                                "facturado",
                                "valor_generado_para_reclamacion",
                            ],
                        });

                        data["A1"].v = "Código";
                        data["B1"].v = "Modelo";
                        data["C1"].v = "Producto";
                        data["D1"].v = "Facturado";
                        data["E1"].v = "Valor generado para reclamación";
                        var workbook = XLSX.utils.book_new();
                        XLSX.utils.book_append_sheet(workbook, data, "Siniestralidad Variable");
                        var wopts = { bookType: "xlsx", bookSST: false, type: "array" };
                        var wbout = XLSX.write(workbook, wopts);
                        saveAs(
                            new Blob([wbout], { type: "application/octet-stream" }),
                            "SiniestralidadVariable.xlsx"
                        );
                        // this.$toasted.show("Archivo exportado correctamente", {
                        //     theme: "toasted-primary",
                        //     position: "top-right",
                        //     duration: 5000,
                        // });
                    } catch (error) {
                        this.$toasted.show(
                            "Ocurrió un error al intentar exportar el archivo",
                            {
                                theme: "toasted-primary",
                                position: "top-right",
                                duration: 10000,
                            }
                        );
                    }
                    break;
                default:
                    break;
            }
            this.loading = false;
        },
    },
    mounted() {
        this.generarInforme();
    },
}
</script>

<style scoped>

</style>